import PropTypes from 'prop-types';
import React from 'react';

import { labels } from '@constants/Messages';
import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Dimmer from '@shared/components/ui/Dimmer';
import { getLabel, getMessage } from '@shared/utils';

const ConfirmDialog = (props) => {
  const {
    onClose = () => {},
    onConfirm,
    onCancel,
    open,
    title = getMessage('areYouSure'),
    dimmer = false,
    error = null,
    confirmText = labels.yes,
  } = props;

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose(false);
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose(true);
    }
  };

  return (
    <Dialog onClose={handleCancel} open={open} maxWidth="xs" fullWidth>
      <Dimmer active={dimmer}>
        <DialogTitle>{title}</DialogTitle>
        {error && (
          <DialogContent sx={{ pt: 0 }}>
            <Alert severity="error" style={{ maxWidth: '100%', margin: '10px 24px' }}>
              <AlertTitle>{getLabel('error')}</AlertTitle>
              {getMessage(error?.code) || error?.message}
            </Alert>
          </DialogContent>
        )}
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button variant="outlined" onClick={handleCancel} className="negative">
            {labels.cancel}
          </Button>
          <Button variant="contained" color="primary" onClick={handleConfirm} className="positive">
            {confirmText}
          </Button>
        </DialogActions>
      </Dimmer>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  dimmer: PropTypes.bool,
  error: PropTypes.object,
  confirmText: PropTypes.string,
};

export default ConfirmDialog;
